import React, { useEffect, useState } from "react";
import ExclusiveBlockSwiper from "./ExclusiveBlockSwiper";
import { Link } from "react-router-dom";
import instance from "../../lib/axios";
import CurrencyConverter from "./CurrencyConverter";
import { ScrollingImages } from "./ScrollingImages";

const Home = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fetchData = async () => {
    try {
      const response = await instance.post("/api/convert/");
      console.log(response);

      if (response.data && Array.isArray(response.data.currencies)) {
        setCurrencies(response.data.currencies);
      } else {
        setCurrencies([]);
      }
    } catch (err) {
      console.error("Error fetching currencies:", err);
      setCurrencies([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // fetchData();
  }, []);

  const images1 = [
    "https://nimofx.com/wp-content/uploads/2024/12/Group-1171277538.svg",
    "https://nimofx.com/wp-content/uploads/2024/12/Group-1171277540.svg",
    "https://nimofx.com/wp-content/uploads/2024/12/Group-1171277542.svg",
  ];

  const images2 = [
    "https://nimofx.com/wp-content/uploads/2024/12/Group-1171277539.svg",
    "https://nimofx.com/wp-content/uploads/2024/12/Group-1171277541.svg",
    "https://nimofx.com/wp-content/uploads/2024/12/Group-1171277543.svg",
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div
        className="px-6 py-4 md:px-[4.5rem] md:pt-[2.19rem] md:pb-[3.75rem] text-center bg-cover bg-center min-h-auto md:flex items-center md:gap-[10rem] min-[1440px]:gap-[10rem] min-[1024px]:gap-0  overflow-x-hidden overflow-y-auto inset-0"
        style={{ backgroundImage: "url(/assets/Bgred.svg)" }}
      >
        <div className="md:w-1/2">
          <div className="md:w-full">
            <div className="md:flex gap-[0.4rem] items-center mb-4 hidden">
              {/* <div className=" bg-white rounded-[0.125rem] shadow-[0px_1px_2.5px_0px_rgba(0,0,0,0.25)] p-[0.3rem]">
                <img
                  src="/assets/playStoreIcon.svg"
                  alt="playstoreIcon"
                  className="w-[0.86575rem] h-[0.86575rem]"
                />
              </div> */}
              {/* <div className="text-[#fff] font-semibold md:text-[0.89494rem]">
                4.8
              </div> */}
              {/* <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="9"
                  viewBox="0 0 10 9"
                  fill="none"
                >
                  <path
                    d="M5 7.53723L7.42493 8.91839C7.86901 9.17151 8.41243 8.79733 8.29556 8.3241L7.65281 5.72686L9.79727 3.97703C10.1888 3.65787 9.9784 3.05258 9.4642 3.01407L6.64194 2.78846L5.53757 0.334285C5.33891 -0.111428 4.66109 -0.111428 4.46243 0.334285L3.35806 2.78296L0.535796 3.00856C0.021595 3.04708 -0.18876 3.65237 0.202734 3.97152L2.34719 5.72136L1.70444 8.3186C1.58757 8.79183 2.13099 9.16601 2.57507 8.91289L5 7.53723Z"
                    fill="#FFDB25"
                  />
                </svg>
              </div> */}
              {/* <div className="text-[0.89494rem] font-medium text-[#FFF]">
                {" "}
                Star on Google Play Store
              </div> */}
            </div>
            <h2 className="text-[2.75rem] md:text-[4.375rem] text-[#fff] font-bold md:text-left mt-32 md:mt-0 leading-[3.125rem] md:leading-[5.375rem]">
              Global Spending, Greater Savings
 
              <br /> <span className="font-normal"></span>
            </h2>
            <p className="md:w-full md:text-left text-white md:mt-7 md:mb-[3.69rem] mb-[1.19rem] text-[0.75rem] md:text-base font-medium mt-3">
              Nimo makes it easy to keep more of what you earn while spending
              smartly around the globe. Whether you’re traveling, sending
              remittances, or managing business expenses, we’ve got you covered.
            </p>
            <div className="flex justify-center md:justify-start mb-[2.82rem] md:mb-0">
              <img src="/assets/googleplayAndAppStoreIcon.svg"  alt="googleplayAndAppStoreIcon" className="w-[14rem]"/>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 md:flex justify-end">
          <CurrencyConverter />
        </div>
      </div>

      <div className="md:mt-12 flex flex-col-reverse md:flex-row  md:px-[4.5rem] mb-12 md:mb-0">
        <div className="md:w-[50%] px-6 md:px-0">
          <h2 className="text-[#1D1D1D] text-[3.375rem] md:text-[5.52094rem] min-[1440px]:text-[5.52094rem] min-[1024px]:text-[3.5rem] font-light md:text-left leading-[4.26081rem] md:leading-[6.57813rem] min-[1440px]:leading-[6.57813rem] min-[1024px]:leading-[4.57813rem] mb-7 text-center">
            The Smart <br /> Way to <br />{" "}
            <span className="font-bold">
              Spend <br />
              <span className="text-[#DC143C]">Anywhere.</span>
            </span>
          </h2>
          <div className="min-[1700px] xl:w-[80%] inline-flex md:items-start md:content-start justify-center md:justify-start flex-wrap gap-y-[1.125rem] gap-x-[0.85013rem] md:gap-x-[1.3125rem]">
            <div className="flex justify-center items-center gap-[0.40481rem] md:gap-[0.625rem] py-[0.24288rem] px-[1.174rem] md:py-[0.375rem] md:px-[1.8125rem] border border-[#C7C7C7] rounded-[0.24288rem] md:rounded-[0.375rem] transition-all duration-300 hover:transform hover:scale-110 hover:shadow-md cursor-pointer">
              <div>
                <img src="/assets/ForexCardIcon.png" alt="ForexCardIcon" />
              </div>
              <div className="text-[#303030] text-[0.64775rem] md:text-base font-medium ">
                Forex Cards
              </div>
            </div>
            <div className="flex justify-center items-center gap-[0.40481rem] md:gap-[0.625rem] py-[0.24288rem] px-[1.174rem] md:py-[0.375rem] md:px-[1.8125rem] border border-[#C7C7C7] rounded-[0.24288rem] md:rounded-[0.375rem] transition-all duration-300 hover:transform hover:scale-110 hover:shadow-md cursor-pointer">
              <div>
                <img src="/assets/NohiddenIcon.png" alt="NohiddenIcon" />
              </div>
              <div className="text-[#303030] text-[0.64775rem] md:text-base font-medium">
                No Hidden Charges
              </div>
            </div>
            <div className="flex justify-center items-center gap-[0.40481rem] md:gap-[0.625rem] py-[0.24288rem] px-[1.174rem] md:py-[0.375rem] md:px-[1.8125rem] border border-[#C7C7C7] rounded-[0.24288rem] md:rounded-[0.375rem] transition-all duration-300 hover:transform hover:scale-110 hover:shadow-md cursor-pointer">
              <div>
                <img src="/assets/lowCostIcon.png" alt="lowCostIcon" />
              </div>
              <div className="text-[#303030] text-[0.64775rem] md:text-base font-medium">
                Low-Cost Remittances
              </div>
            </div>
            <div className="flex justify-center items-center gap-[0.40481rem] md:gap-[0.625rem] py-[0.24288rem] px-[1.174rem] md:py-[0.375rem] md:px-[1.8125rem] border border-[#C7C7C7] rounded-[0.24288rem] md:rounded-[0.375rem] transition-all duration-300 hover:transform hover:scale-110 hover:shadow-md cursor-pointer">
              <div>
                <img
                  src="/assets/BestExchangeIcon.png"
                  alt="BestExchangeIcon"
                />
              </div>
              <div className="text-[#303030] text-[0.64775rem] md:text-base font-medium">
                Best Exchange Rates
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 flex justify-between">
          {/* <img src="/assets/thesmartLeftImg.png" alt="thesmartLeftImg" /> */}
          <div className="container">
            <ScrollingImages
            // images1={images1}
            // images2={images2}
            // speed={10}
            // direction={1}
            // pauseOnHover={true}
            // heightDesktop="600px"
            // heightTablet="400px"
            // heightMobile="300px"
            />
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-b from-white to-gray-100 md:pl-[4.5rem] pl-6 md:pt-[2.16rem] mt-20">
        <div className="flex flex-col-reverse md:flex-row md:justify-between items-center justify-center">
          <div className="md:w-1/2 flex flex-col items-center md:items-start mt-8 md:mt-0">
            <div className="pr-6 md:pr-0 md:w-2/3">
              <h2 className="text-[#1D1D1D] text-[1.625rem]  md:text-[3.25rem] min-[1440px]:text-[3.35rem] min-[1024px]:text-[2.35rem] text-center md:text-left font-light mb-8 md:leading-[4.375rem] min-[1440px]:leading-[4.375rem] min-[1024px]:leading-[3.375rem]">
                <span className="font-bold">Experience More with<span className="text-[#DC143C]"> nimo</span>:</span>{" "}
                Beyond Just a Forex Card
              </h2>
              <div className="flex justify-center md:justify-start">
                <Link to={"/forex-cards"}>
                  <button className="text-white font-[Figtree] text-[0.75rem] md:text-[1.25rem] font-semibold leading-[2.375rem] bg-[#DC143C] py-[0.57rem] px-[1.375rem] rounded-lg">
                    Get Your Card Today
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-end">
            <img src="/assets/ExclusiveCard.svg" alt="ExclusiveCard" />
          </div>
        </div>
        <ExclusiveBlockSwiper />
      </div>

      {/* <div className="overflow-hidden py-8 bg-white my-4 md:my-[3rem]">
        <div className="relative flex w-full">
          <div className="flex animate-scroll items-center md:gap-[6.31rem] gap-[1.98rem]">
            Logos (Duplicated for smooth scrolling)
            {[...Array(2)].flatMap(() =>
              [
                "https://paywize.in/wp-content/uploads/2025/01/Screenshot-2024-10-07-100437-2.svg",
                "https://paywize.in/wp-content/uploads/2025/01/images-1.svg",
                "https://paywize.in/wp-content/uploads/2025/01/pngwing.com_.svg",
                "https://paywize.in/wp-content/uploads/2025/01/CSB_Bank_New_Logo-02.svg.svg",
                "https://paywize.in/wp-content/uploads/2025/01/logo_crop_reduce1.svg",
              ].map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt="AU Small Finance Bank"
                  className="w-24"
                />
              ))
            )}
          </div>
        </div>
      </div> */}

      <div className="md:flex md:pl-[4.5rem] md:pr-0 pl-6">
        <div className="md:w-[50%]">
          <h2 className="text-[#1D1D1D] pr-6 text-[2.75rem] text-center md:text-left md:text-[3.25rem] font-bold font-[Figtree] leading-[3.875rem] mb-10 md:mb-16">
            Your All-in-One Mobile App for Foreign Spending
          </h2>
          <div className="pr-6 md:pr-0">
            {/* Collapsible FAQ Items */}
            {[
              {
                image: "/assets/Layer_1.png",
                question: "Multi-Currency Wallet",
                answer:
                  "Guaranteed industry-best exchange rates ensure you get the most out of every transaction. We eliminate hidden fees, providing complete transparency in our pricing structure.",
              },
              {
                image: "/assets/Layer_2.png",
                question: "Track Spending in Real-Time",
                answer:
                  "Get instant updates on your transactions and track your spending abroad.",
              },
              {
                image: "/assets/Layer_3.png",
                question: "Seamless Forex Card Management",
                answer:
                  "Reload, lock in exchange rates, and manage your Nimo Forex Card all through the app.",
              },
              {
                image: "/assets/Layer_4.png",
                question: "Instant Currency Conversion",
                answer:
                  "Know exactly how much you’re spending with live currency conversion rates at your fingertips.",
              },
              {
                image: "/assets/Layer_5.png",
                question: "Instant Notifications",
                answer:
                  "Get immediate updates on every transaction, helping you stay on top of your foreign spending.",
              },
              {
                image: "/assets/Layer_6.png",
                question: "24/7 Customer Support",
                answer:
                  "Access customer support at any time to resolve issues or ask questions about your account.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className={`rounded-[1.375rem] p-4 md:p-6 text-left md:mt-6 mt-3 cursor-pointer transition-all duration-300 
                        ${
                          openIndex === index
                            ? "border border-black bg-[#FFF2F5] shadow-[0px_6px_12.9px_-3px_rgba(0,0,0,0.14)]"
                            : "border border-[rgba(0,0,0,0.25)]"
                        }`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-6">
                    <img src={faq.image} alt={faq.question} />
                    <h3
                      className={`text-[0.75rem] md:text-[1.25rem] leading-normal text-[#1D1D1D] font-[Figtree] tracking-tight 
                                ${
                                  openIndex === index
                                    ? "font-bold"
                                    : "font-medium"
                                }`}
                    >
                      {faq.question}
                    </h3>
                  </div>
                  <span className="text-xl font-bold">
                    {openIndex === index ? (
                      <img
                        src="/assets/UpArrow.png"
                        alt="Collapse"
                        className=""
                      />
                    ) : (
                      <img
                        src="/assets/DownArrow.png"
                        alt="Expand"
                        className=""
                      />
                    )}
                  </span>
                </div>
                {openIndex === index && (
                  <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1rem] font-medium mt-2 leading-[1.5625rem]">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="md:w-[50%] flex md:justify-end justify-start relative">
          {/* <div className="absolute left-[13%] bottom-[2%] md:bottom-[12%]  xl:bottom-[12%] min-[1440px]:bottom-[8%] min-[1500px]:bottom-[4%] min-[1700px]:bottom-[4%] min-[1700px]:left-[50%] md:left-[42%] min-[1024px]:left-[18%] min-[1200px]:left-[32%] min-[1280px]:left-[32%]  min-[1440px]:left-[42%] min-[1920px]:left-[56%] min-[2560px]:left-[66%] min-[2560px]:bottom-[4%]">
            <div>
              <h2 className="text-[#DC143C] md:text-[2.25rem] font-extrabold tracking-[-0.045rem]">
                100 + Hrs
              </h2>
              <h2 className="text-[#8C8C8C] md:text-[1.125rem] font-normal tracking-[-0.0225rem]">
                User Views
              </h2>
            </div>
            <div className="my-8">
              <h2 className="text-[#DC143C] md:text-[2.25rem] font-extrabold tracking-[-0.045rem]">
                50 Million +
              </h2>
              <h2 className="text-[#8C8C8C] md:text-[1.125rem] font-normal tracking-[-0.0225rem]">
                Active Users
              </h2>
            </div>
            <div>
              <h2 className="text-[#1D1D1D] md:text-[2.25rem] font-extrabold tracking-[-0.045rem]">
                $ 4 Million +
              </h2>
              <h2 className="text-[#8C8C8C] md:text-[1.125rem] font-normal tracking-[-0.0225rem]">
                Transactions
              </h2>
            </div>
          </div> */}
          <div>
            <img src="/assets/MOBILEAppIcon.svg" alt="MOBILEAppIcon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
